import * as Utils from '@ext/index';
export { };


export class Estados
{

    constructor( id: string, descripcion: string )
    {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Estados
    {

        if ( id === this.Activa.Id ) return this.Activa;
        return new Estados( id, id.toString() );
    }

    public static Activa: Estados = new Estados( "Activo", "Activo" );

    public get esActiva(): boolean { return this.Id === Estados.Activa.Id; }

    public static Filter = [
        { Id: 0, Nombre: 'Todos', Valor: [] },
        { Id: 1, Nombre: Estados.Activa.Descripcion, Valor: [Estados.Activa] },
    ];
}

export class Tipos
{

    constructor( id: string, descripcion: string )
    {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Tipos
    {

        if ( id === this.Normal.Id ) return this.Normal;
        else if ( id === this.Nacional.Id ) return this.Nacional;
        else if ( id === this.Importado.Id ) return this.Importado;
        else if ( id === this.ImportadoTerceros.Id ) return this.ImportadoTerceros;
        else if ( id === this.ImportadoSinReposicion.Id ) return this.ImportadoSinReposicion;
        return new Tipos( id, id.toString() );
    }

    public static Normal: Tipos = new Tipos( "normal", "Normal" );
    public static Nacional: Tipos = new Tipos( "nacional", "Nacional" );
    public static Importado: Tipos = new Tipos( "importado-propio", "Importado" );
    public static ImportadoTerceros: Tipos = new Tipos( "importado", "Importado por terceros" );
    public static ImportadoSinReposicion: Tipos = new Tipos( "importado-sin-reposicion", "Importado sin reposición" );

    public get esNormal(): boolean { return this.Id === Tipos.Normal.Id; }
    public get esNacional(): boolean { return this.Id === Tipos.Nacional.Id; }
    public get esImportado(): boolean { return this.Id === Tipos.Importado.Id; }
    public get esImportadoTerceros(): boolean { return this.Id === Tipos.ImportadoTerceros.Id; }
    public get esImportadoSinReposicion(): boolean { return this.Id === Tipos.ImportadoSinReposicion.Id; }

    public static Filter = [
        { Id: 0, Nombre: 'Todos', Valor: [] },
        { Id: 1, Nombre: Tipos.Nacional.Descripcion, Valor: [Tipos.Nacional] },
        { Id: 2, Nombre: Tipos.Importado.Descripcion, Valor: [Tipos.Importado] },
        { Id: 3, Nombre: Tipos.ImportadoTerceros.Descripcion, Valor: [Tipos.ImportadoTerceros] },
        { Id: 4, Nombre: Tipos.ImportadoSinReposicion.Descripcion, Valor: [Tipos.ImportadoSinReposicion] },
        { Id: 4, Nombre: 'Todo lo importado', Valor: [Tipos.Importado, Tipos.ImportadoTerceros,Tipos.ImportadoSinReposicion] },
    ];
}
